function waitForMessage(matchFn: (event: any) => boolean, timeout = 4000) {
  return new Promise((resolve, reject) => {
    const timer = setTimeout(() => {
      cleanup()
      reject(new Error("Request timed out"))
    }, timeout)

    const handler = (event: any) => {
      if (!matchFn(event)) return
      cleanup()
      resolve(event.data.payload?.data || event.data.payload?.linkedinUrl)
    }

    function cleanup() {
      clearTimeout(timer)
      window.removeEventListener("message", handler)
    }

    window.addEventListener("message", handler)
  })
}

export function getLinkedinCookie() {
  if (!document.querySelector("orbitshift-ui")) {
    return Promise.reject(new Error("UI not found"))
  }

  window.postMessage(
    {
      source: "orbitshift",
      type: "FETCH_LINKEDIN_COOKIE",
      payload: { websiteName: "LinkedIn" }
    },
    "*"
  )

  return waitForMessage(
    (event) =>
      event.data?.source === "orbitshift" &&
      event.data?.type === "response" &&
      event.data?.payload?.type === "FETCH_LINKEDIN_COOKIE"
  )
}

export function connectLinkedin(
  linkedin_url: string,
  name: string,
  note: string
) {
  window.postMessage(
    {
      source: "orbitshift",
      type: "SEND_LINKEDIN_MESSAGE",
      payload: { linkedin_url, name, note }
    },
    "*"
  )
  return Promise.resolve(true)
}

export function getLinkedinUrl() {
  window.postMessage(
    {
      source: "orbitshift",
      type: "FETCH_LINKEDIN_URL"
    },
    "*"
  )

  return waitForMessage(
    (event) =>
      event.data?.source === "orbitshift" &&
      event.data?.type === "response" &&
      event.data?.payload?.type === "FETCH_LINKEDIN_URL"
  )
}

// The signed-in user's OWN profile url, for stamping onto their captured
// connections. Never throws: the bridge rejects on a 4s timeout and the
// payload arrives as either a bare string or an object, and a capture that
// works is worth more than a capture that is perfectly attributed.
export async function ownLinkedinUrl(): Promise<string> {
  try {
    const raw = (await getLinkedinUrl()) as
      | string
      | { linkedinUrl?: string; url?: string }
      | null
    const url =
      typeof raw === "string" ? raw : raw?.linkedinUrl || raw?.url || ""
    return String(url || "").trim()
  } catch {
    return ""
  }
}

export function fetchLinkedinConnections(start: number) {
  if (!document.querySelector("orbitshift-ui")) {
    return Promise.reject(new Error("UI not found"))
  }

  window.postMessage(
    {
      source: "orbitshift",
      type: "FETCH_LINKEDIN_CONNECTIONS",
      payload: { start }
    },
    "*"
  )

  return waitForMessage(
    (event) =>
      event.data?.source === "orbitshift" &&
      event.data?.type === "response" &&
      event.data?.payload?.type === "FETCH_LINKEDIN_CONNECTIONS",
    20000
  ) as Promise<{
    start: number
    connections: {
      firstName: string
      lastName: string
      headline: string
      publicIdentifier: string
    }[]
    totalCount: number
    status: number
    error?: string
  }>
}
